import largeProjects from "./largeProjects";
import smallProjects from "./smallProjects";
import mediumProjects from "./mediumProjects";

const gsocIdeas = {
    largeProjects,
    smallProjects,
    mediumProjects,
};

export default gsocIdeas;
